const data=[
    {
        text: 'Clear Class X board exam with 92% marks',
        year: '2016',
        category:{
            tag: 'SECONDARY',
            color: '#FFDB14'
        }
    },
    {
        text: 'Clear Class XII board exam with 90.2% marks',
        year: '2018',
        category:{
            tag: 'HIGHER SECONDARY',
            color: '#e17b77'
        }
    },
    {
        text: 'Complete WBJEE exam with ... ranks',
        year: '2018',
        category:{
            tag: 'WBJEE',
            color: '#1DA1F2'
        }
    },
    {
        text: 'Complete JEE exam with ... ranks',
        year: '2018',
        category:{
            tag: 'JEE MAIN',
            color: '#018f69'
        }
    },
    {
        text: 'Join MAKAUT',
        year: '2018',
         category:{
            tag: 'B.TECH',
            color: '#FFDB14'
        }
    }
    
];

export default data